/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { RenderTileRequest } from '../../models/render-tile-request';

export interface RenderTiles$Params {
   body: RenderTileRequest;
}

export function renderTiles(
   http: HttpClient,
   rootUrl: string,
   params: RenderTiles$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<void>> {
   const rb = new RequestBuilder(rootUrl, renderTiles.PATH, 'post');
   if (params) {
      rb.body(params.body, 'application/json');
   }

   return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
   );
}

renderTiles.PATH = '/api/weather/tiles';
